import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormattedMessage } from "react-intl";
import useAuthStore from "../../stores/useAuthStore";

function MobileLogout() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const signOut = useAuthStore((state) => state.signOut);

  const toggle = () => {
    setDropdownOpen(!dropdownOpen);
  };

  var role = localStorage.getItem("role") ? localStorage.getItem("role") : "";
  var email = localStorage.getItem("email");
  var displayRole = "Views.Header.DisplayLoginRole" + role;

  if (role !== "") {
    return (
      <ButtonDropdown
        id="mobile__logout"
        isOpen={dropdownOpen}
        toggle={toggle}
      >
        <DropdownToggle id="mobile__logout-toggler">
          <FontAwesomeIcon
            title="Info"
            icon="user"
            style={{ cursor: "pointer" }}
          />
        </DropdownToggle>
        <DropdownMenu id="mobile__logout-menu">
          <DropdownItem header>
            <FormattedMessage id="Views.Header.DisplayLoginRole" />
            &nbsp;{email} (<FormattedMessage id={displayRole} />)
          </DropdownItem>
          <DropdownItem divider />
          <DropdownItem onClick={signOut}>Logga ut</DropdownItem>
        </DropdownMenu>
      </ButtonDropdown>
    );
  } else {
    return null;
  }
}

export default MobileLogout;
